<template>
  <transition name="el-zoom-in-top">
    <el-dialog title="出库单导出明细(最新5条)" :visible.sync="show" width="65%" :modal-append-to-body='true'>
      <div style="text-align: left;">
        <el-button slot="reference" class="bottstycz" type="primary" size="mini" @click="toExportRequest(row)">计划导出</el-button>
        <el-button slot="reference" class="el-icon-refresh" type="primary" size="mini" @click="getTabledata()">刷新</el-button>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="6">
            <span style="font-weight: bold;"> 运单号：</span>{{ row.freight_bill_code }}
          </el-col>
          <el-col :span="4">
            <span style="font-weight: bold;"> 出库单号：</span>{{ row.out_bill_code }}
          </el-col>
          <el-col :span="5">
            <span style="font-weight: bold;"> 客户编码：</span>{{ row.dealer_code }}
          </el-col>
          <el-col :span="8">
            <span style="font-weight: bold;"> 客户名称：</span>{{ row.dealer_name }}
          </el-col>
        </el-row>

        <el-divider></el-divider>
        <el-table :data="tableData" style="width: 100%" max-height="300" highlight-current-row>
          <af-table-column fixed prop="id" label="ID" width="150">
          </af-table-column>
          <af-table-column prop="createtimeStr" label="导出时间">
          </af-table-column>
          <af-table-column prop="statusStr" label="状态"> </af-table-column>
          <el-table-column fixed="right" label="下载" min-width="250">
            <template slot-scope="props">

              <el-button type="primary" @click="exportDownload(props.row)" class="bottstycz" v-if="props.row.status == 1">
                下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </transition>
</template>
<script>
import {
  outExportList,
  outExportRequest,
  exportDataDownload
} from "@/api/plant";
export default {
  props: {
    search: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      reality_instorage: 0,
      row: {},
      tableData: [],
      //基础数据
      show: false,
      editshow: false,
      awardform: {}
    };
  },
  mounted () { },
  methods: {
    toExportRequest (row) {
      this.$confirm("此操作将出库导出指令,是否继续?","提示",{
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        modal: true,
        type: "warning"
      })
        .then(() => {
          outExportRequest({
            freight_bill_code: row.freight_bill_code
          }).then(response => {
            if(response.status_code==200) {
              this.$message({
                type: "success",
                message: "发送成功!"
              });
              this.getTabledata();
            } else {
              this.$message({
                type: "woring",
                message: "发送失败!请检查字段"
              });
            }
          });
        })
        .catch(() => {
        });
    },
    exportDownload (row) {
      console.log(row);
      if(row.status==1) {
        var url=decodeURIComponent(row.oss_url);
        var link = document.createElement("a");
        link.download = url.substring(url.lastIndexOf('/')+1);
        fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
          link.href = URL.createObjectURL(blob)
          document.body.appendChild(link)
          link.click()
        })
      }
    },
    getTabledata () {
      // 列表获取
      this.listLoading=true;
      outExportList({ freight_bill_code: this.row.freight_bill_code }).then(response => {
        this.listLoading=false;
        for(let i=0;i<response.data.length;i++) {
          response.data[i].statusStr=response.data[i].status==0? "正在导出":"已完成";
          response.data[i].createtimeStr=response.data[i].createtime.replace('T',' ');
        }
        this.tableData=response.data;
        this.show=true;
        console.log(response.data);
      });
    }
  }
};
</script>

<style>
</style>
